import Vue from 'vue'
import App from './App'
import router from '@/router'
import './icons/index'; // SvgIcon
import './permission' // 权限
import './error' // 日志
import './cache' // 页面缓存
import store from '@/store'
import Element from 'element-ui'
import VueClipboard from 'vue-clipboard2'
import i18n from '@/lang' // Internationalization
import '@/styles/common.scss'
import basicContainer from '@/components/basic-container/main'

import TablePagination from '@/components/TablePagination';
import DateRangeDestructor from '@/components/DateRangeDestruct';
import ATable from '@/components/ATable';
import website from '@/config/website'
import * as filters from '@/util/filters'
import auth from '@/directive/auth.js';
import authority from '@/directive/authority.js'
import AvueUeditor from 'avue-plugin-ueditor';
import component from '@/components/VueText'
import ElementDialog from "@/components/element-dialog";

Vue.use(ElementDialog)
Vue.use(component)
Vue.use(VueClipboard)
Vue.use(AvueUeditor);
Vue.use(router)
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(window.AVUE, {
  i18n: (key, value) => i18n.t(key, value)
})
//注册全局容器
Vue.use(TablePagination);
Vue.use(DateRangeDestructor);
Vue.use(ATable);
Vue.component('basicContainer', basicContainer)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(auth)
Vue.use(authority)
// 加载website
Vue.prototype.website = website

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
